import React, { ReactNode } from 'react';
import NotFound from '~/App/shared/components/NotFound';
import useLocalization from '~/App/shared/hooks/useLocalization';
import { isExportDomain } from '~/App/shared/localization/helpers';
import { RouteComponentProps } from '~/App/shared/interfaces/routes';
import { RouteConfig } from '~/config/routes/types';
import {
  isSwedishDomainOnlyBranch,
  matchRoutes
} from '~/config/routes/matchRoutes';

type Props = Pick<RouteComponentProps, 'location' | 'staticContext'> & {
  route: RouteConfig;
  children: ReactNode;
};

const SwedishDomainOnlyGuard = ({
  route,
  location,
  staticContext,
  children
}: Props) => {
  const { domainLocale } = useLocalization();

  if (
    isExportDomain(domainLocale) &&
    isSwedishDomainOnlyBranch(matchRoutes([route], location.pathname))
  ) {
    return <NotFound staticContext={staticContext} />;
  }

  return <>{children}</>;
};

export default SwedishDomainOnlyGuard;
